import { message } from 'antd';

const BASE_URL = '/api/v1/abdmserv';

const headers = {
  'sec-ch-ua-platform': 'macOS',
  'tenantId': 'OrgLanceHIMS',
  'Accept': 'application/json',
  'env': 'dev',
  'Content-Type': 'application/json',
  'Referrer-Policy': 'noreferrer',
  'Access-Control-Allow-Origin': '*',
  'Access-Control-Allow-Methods': 'POST',
  'Access-Control-Allow-Headers': 'Content-Type, Authorization'
};

export const generateOTP = async (aadhaarNumber) => {
  try {
    const response = await fetch(`${BASE_URL}/otp/generate/${aadhaarNumber.replace(/\s/g, '')}`, {
      method: 'POST',
      headers
    });
    
    const data = await response.json();
    if (data.responseCode === 200) {
      message.success(data.responseObject.message);
      // Return the complete data object so React component can access txnId
      return data;
    } else {
      throw new Error('Failed to generate OTP');
    }
  } catch (error) {
    message.error('Failed to generate OTP');
    throw error;
  }
};

export const validateOTP = async (otp, txnId, mobileNumber, hasMobileVerification = true) => {
  try {
    // Validate inputs before making the request
    if (!otp || otp.trim() === '') {
      throw new Error('OTP cannot be empty');
    }
    if (!txnId || txnId.trim() === '') {
      throw new Error('Transaction ID cannot be empty');
    }

    const payload = {
      otp: otp, // ABDM API expects 'otpValue' not 'otp'
      txnId: txnId,
      timestamp: new Date().toISOString().replace('T', ' ').substring(0, 19), // Format: YYYY-MM-DD HH:MM:SS
      ...(mobileNumber && { mobileNumber }), // Only include if provided
      ...(hasMobileVerification !== undefined && { hasMobileVerification })
    };

    console.log('Validation payload:', payload); // Debug log

    const response = await fetch(`${BASE_URL}/otp/validate`, {
      method: 'POST',
      headers,
      body: JSON.stringify(payload)
    });
    
    const data = await response.json();
    if (data.responseCode === 200) {
      message.success('OTP validated successfully');
      return data;
    } else {
      // Log the full error response for debugging
      console.error('OTP validation failed:', data);
      throw new Error(data.responseMessage || 'OTP validation failed');
    }
  } catch (error) {
    console.error('Validation error:', error);
    message.error(error.message || 'Failed to validate OTP');
    throw error;
  }
};